import { defineComponent as i, openBlock as n, createBlock as r, unref as a, createSlots as p, withCtx as o, renderSlot as l } from "vue";
import { NPerformantEllipsis as d } from "naive-ui";
import { COMPONENT_NAME as s } from "./highrise.es166.js";
const f = i({
  name: s.ELLIPSIS,
  inheritAttrs: !1
}), h = /* @__PURE__ */ i({
  ...f,
  props: {
    id: {
      type: String,
      default: "hr-ellipsis-id"
    },
    expandOn: {
      type: String
    },
    lineClamp: {
      type: Number,
      default: 1
    },
    tooltipProps: {
      type: [Boolean, Object, void 0]
    },
    showTooltip: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    return (e, m) => (n(), r(a(d), {
      id: t.id,
      "expand-trigger": t.expandOn,
      "line-clamp": t.lineClamp,
      tooltip: t.showTooltip ? t.tooltipProps : !1
    }, p({
      default: o(() => [
        l(e.$slots, "default")
      ]),
      _: 2
    }, [
      e.$slots.tooltip ? {
        name: "tooltip",
        fn: o(() => [
          l(e.$slots, "tooltip")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["id", "expand-trigger", "line-clamp", "tooltip"]));
  }
});
export {
  h as default
};
//# sourceMappingURL=highrise.es108.js.map
